// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Grace_PeriodRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Grace_PeriodRow — one row for GET /subscriptions/grace/list.
 *
 * Covers ALL franchises_grace_periods rows (live + expired + revoked).
 * franchise_name is injected by the controller via permissoes_model.
 * plan_id is the plan the grace period was granted for (nullable — legacy
 * rows created before plan_id existed on the write path). plan_name is
 * resolved from plan_id via subscription_plans (nullable when plan_id is
 * null).
 * Datetime fields are ISO-8601 UTC strings (controller converts GMT-3 before fromRows()).
 * is_live and days_remaining are derived by the controller:
 *   is_live  = ends_at >= now AND revoked_at IS NULL
 *   days_remaining = floor((ends_at - now) / 86400) when is_live, else null.
 *
 * FLOOR, não ceil (S12/M0): arredondar para cima promete um dia que não existe, e o
 * portão de acesso usa floor — staff e franqueado precisam ler o mesmo número. `now`
 * é sempre now_gmt3(), nunca o NOW() do MySQL (UTC neste container, contra ends_at
 * gravado em GMT-3).
 */
import { registerContract } from './validate'

export interface Grace_PeriodRow {
grace_id: number
franquia_id: number
franchise_name?: string
subscription_id?: number
plan_id?: number
plan_name?: string
starts_at?: string
ends_at?: string
source?: string
granted_by?: string
reason?: string
revoked_at?: string
revoked_by?: string
is_live?: boolean
days_remaining?: number
}

registerContract('Grace_PeriodRow', {
  grace_id:        { type: 'number',  required: true },
  franquia_id:     { type: 'number',  required: true },
  franchise_name:  { type: 'string',  required: false },
  subscription_id: { type: 'number',  required: false },
  plan_id:         { type: 'number',  required: false },
  plan_name:       { type: 'string',  required: false },
  starts_at:       { type: 'string',  required: false },
  ends_at:         { type: 'string',  required: false },
  source:          { type: 'string',  required: false },
  granted_by:      { type: 'string',  required: false },
  reason:          { type: 'string',  required: false },
  revoked_at:      { type: 'string',  required: false },
  revoked_by:      { type: 'string',  required: false },
  is_live:         { type: 'boolean', required: false },
  days_remaining:  { type: 'number',  required: false },
})
